<template>
  <div class="service-links">
    <hr class="hr-divider margin-top-s margin-bottom-s" />
    <CategoryHeading :title="mobileTitles.moreToExplore" />
    <ul class="grid-y hnf-service-links">
      <li v-if="isDomestic && isRegistryDropdown" class="grid-x align-middle" :class="{ 'l1-category-active': stack[0]?.id === 'registry' }">
        <RegistryServiceLink />
      </li>
      <li v-for="(service, index) in items" :key="service.text" class="grid-x align-middle">
        <ServiceLink :item="service" :position="index" />
      </li>
      <li v-if="mounted && internationalContextEnabled" class="grid-x align-middle">
        <InternationalServiceLink />
      </li>
    </ul>
  </div>
</template>

<script setup>
/* v8 ignore file -- @preserve */
import { computed } from 'vue';
import { useMounted } from '@vueuse/core';
import { mobileTitles } from 'config';
import RegistryServiceLink from './RegistryServiceLink.common';
import ServiceLink from './ServiceLink.common';
import CategoryHeading from './CategoryHeading.common';
import InternationalServiceLink from './InternationalServiceLink';

import { GET_SECONDARY_NAV } from '#shared/types/getters';
import { useMobileNav } from '~/composables/useMobileNav';
import useKillswitches from '~/composables/useKillswitches';

const pageData = usePageData();
const navHeader = useNavHeader();

const mounted = useMounted();
const { stack } = useMobileNav();
const killswitches = useKillswitches();
const isDomestic = computed(() => pageData.navigation.context.isDomestic);

const items = computed(() => {
  const data = navHeader?.[GET_SECONDARY_NAV];

  if (isDomestic.value) {
    return data.filter(({ text }) => text?.toLowerCase() !== 'stores');
  }

  return data;
});
const isRegistryDropdown = computed(() => !!killswitches.value.registryDropdownEnabled);
const internationalContextEnabled = computed(() => killswitches.value.internationalContextEnabled);
</script>

<style lang="scss" scoped>
.service-links {
  .hnf-service-links {
    gap: map-get($grid-margin-gutters, 'medium');
  }
}
</style>
